import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get, isNil } from 'lodash';
import cn from 'classnames';

import Header from 'components/Header';
import Heading from 'components/Heading';
import Footer from 'components/Footer';
import ProgressBar from 'components/ProgressBar';
import { Grid, Column } from 'components/Layout';
import Plaid from 'components/Plaid';
import { nextAction } from 'actions/workflow';
import { getBlackbox, initIovation } from 'utils/iovation';

import style from './style.scss';

const BankAccountVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const data = useSelector(state => get(state, 'workflow.data.data') || get(state, 'workflow.state.data'));

  useEffect(() => {
    if (!key) {
      navigate('/');
    } else if (isNil(data)) {
      navigate(`/applications/fsl/checkin?key=${key}`);
    }
  }, []);

  useEffect(() => {
    initIovation();
  }, []);

  const handlePlaidSuccess = (publicToken, metadata, sessionId) => {
    const iovationBlackBox = getBlackbox();

    dispatch(nextAction({
      url: `/workflows/fsl/${key}/next`,
      data: {
        isPlaidComplete: true,
        plaidSessionId: sessionId,
        iovationBlackBox: iovationBlackBox || '',
        publicToken: {
          linkSessionId: get(metadata, 'link_session_id'),
          publicToken,
          accounts: (get(metadata, 'accounts') || []).map(acc => ({
            accountId: get(acc, 'id'),
            mask: get(acc, 'mask'),
            name: get(acc, 'name'),
            subtype: get(acc, 'subtype'),
            type: get(acc, 'type'),
          })),
          institution: {
            institutionId: get(metadata, 'institution.institution_id'),
            name: get(metadata, 'institution.name'),
          },
        },
      },
      success: (res) => {
        const nextUrl = get(res, 'data.url') || get(res, 'state.url');
        if (nextUrl) navigate(nextUrl);
      },
      fail: (error) => {
        console.log(error);
      },
    }));
  };

  const handlePlaidExit = () => {
    dispatch(nextAction({
      url: `/workflows/fsl/${key}/next`,
      data: {
        isPlaidComplete: false,
      },
      success: (res) => {
        const nextUrl = get(res, 'data.url') || get(res, 'state.url');
        if (nextUrl) navigate(nextUrl);
      },
      fail: (error) => {
        console.log(error);
      },
    }));
  };

  return (
    <Fragment>
      <Header />
      <section className="grid-container fluid borrowers-apply">
        <div className="grid-container">
          <Grid className="grid-margin-x max-limited">
            {
              <Fragment>
                <Column className={cn('small-12 large-8 large-offset-2', style.plaid)}>
                  <ProgressBar step={3} totalStep={3} />
                  <Heading
                    heading="Bank Account Verification"
                  />
                  <div className={style.iframeContainer}>
                    <Plaid
                      onPlaidSuccess={handlePlaidSuccess}
                      onPlaidExit={handlePlaidExit}
                    />
                  </div>
                </Column>
              </Fragment>
            }
          </Grid>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default BankAccountVerification;
